import '../../utils/index.mjs';
import Badge from './src/badge2.mjs';
export { badgeProps } from './src/badge.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElBadge = withInstall(Badge);

export { ElBadge, ElBadge as default };
//# sourceMappingURL=index.mjs.map
